"use strict";

exports.__esModule = true;
exports.default = void 0;

var _queryString = _interopRequireDefault(require("query-string"));

var _createQueryMiddleware = _interopRequireDefault(require("./createQueryMiddleware"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _createQueryMiddleware.default)(_queryString.default);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/found/node_modules/farce/lib/queryMiddleware.js
// module id = 1227
// module chunks = 0